import React from 'react';

export default function InvoicePdfTemplate({ 
  id = 'invoice-template-root',
  invoiceNo = '-',
  invoiceDate = '-',
  subtotal = 0,
  gstAmount = 0,
  total = 0,
  dueDate = '-',
  clientName = '',
  contactName = '',
  clientAddress = '',
  invoiceTitle = '',
  description = '',
  reference = ''
}) {

  const formatValue = (value) => {
    return (value === null || value === undefined || value === '') ? '' : value;
  };


  return (
    <div id={id} style={{ 
      background: '#fff', 
      color: '#000', 
      padding: '40px 50px', 
      fontFamily: 'Arial, sans-serif', 
      width: '800px',
      fontSize: '12px',
      lineHeight: '1.5'
    }}>
      {/* Header with Logo */}
      <div style={{ textAlign: 'right', marginBottom: '30px' }}>
        <img src="/assets/images/gdc-logo.webp" alt="GDC Consultants Ltd" style={{ maxWidth: '300px', height: 'auto' }} />
      </div>

      {/* Tax Invoice Title with Line */}
      <div style={{ marginBottom: '30px' }}>
        <div style={{ 
          borderBottom: '3px solid #000', 
          fontSize: '20px',
          fontWeight: 'normal',
          letterSpacing: '0.3px'
        }}>
          Tax Invoice
        </div>
      </div>

      {/* Invoice Details Section */}
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '25px' }}>
        <div style={{ width: '50%' }}>
          <div style={{ display: 'flex', gap: '40px', marginBottom: '20px' }}>
            <div>
              <div style={{ fontWeight: 'bold', marginBottom: '2px' }}>Invoice Number</div>
              <div>{formatValue(invoiceNo)}</div>
            </div>
            <div>
              <div style={{ fontWeight: 'bold', marginBottom: '2px' }}>Date</div>
              <div>{invoiceDate}</div>
            </div>
            <div>
              <div style={{ fontWeight: 'bold', marginBottom: '2px' }}>Due Date</div>
              <div>{dueDate}</div>
            </div>
             <div>
              <div style={{ fontWeight: 'bold', marginBottom: '2px' }}>Reference</div>
              <div>{formatValue(reference) ? formatValue(reference) : formatValue(invoiceNo)}</div>
            </div>
          </div>

          <div style={{ marginTop: '20px' }}>
            <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>{formatValue(clientName)}</div>
            <div>{formatValue(contactName)}</div>
            <div style={{ marginTop: '6px' }}>
              <div style={{ fontWeight: 'bold', marginBottom: '2px' }}>{formatValue(clientAddress)}</div>
            </div>
          </div>
        </div>

        <div style={{ width: '45%', textAlign: 'right', fontSize: '12px', lineHeight: '1.6' }}>
          <div>GDC Consultants Ltd</div>
          <div>P: 07 838 0090</div>
          <div>E: hamilton@gdcgroup.co.nz</div>
          <div>W: www.gdcgroup.co.nz</div>
          <div style={{ marginTop: '8px' }}>GST # 103-298-369</div>
        </div>
      </div>

      {/* Costs Section */}
      <div style={{ marginTop: '30px', marginBottom: '25px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '12px', fontSize: '13px' }}>
          <div style={{ fontWeight: 'bold', width: '70%' }}>Costs</div>
          <div style={{ fontWeight: 'bold', textAlign: 'right', width: '30%' }}>Amount<br />(NZD)</div>
        </div>
        
        <div style={{ borderBottom: '2px solid #a8a8a8', marginBottom: '12px' }}>
          <div style={{ fontWeight: 'bold', marginBottom: '8px', fontSize: '12px' }}>Description</div>
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '15px', lineHeight: '1.5', fontSize: '12px' }}>
          <div style={{ width: '70%', marginBottom: '10px' }}>
            <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>
              {formatValue(invoiceTitle)}
            </div>
            <div style={{ fontWeight: 'normal' }}>
              {formatValue(description)}
            </div>
          </div>
          <div style={{ width: '30%', textAlign: 'right', fontWeight: 'normal' }}>
            ${Number(subtotal).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2 })}
          </div>
        </div>

        <div style={{ marginTop: '15px', fontSize: '10px' }}>
          Please use the ref {formatValue(reference) ? formatValue(reference) : formatValue(invoiceNo)} when making payment. Thank you.
        </div>
        
        <div style={{ borderTop: '1px solid #bdbcbcff', marginTop: '20px' }}></div>
      </div>

      {/* Totals Section */}
      <div style={{ marginTop: '30px', display: 'flex', justifyContent: 'flex-end' }}>
        <div style={{ width: '280px', fontSize: '12px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0' }}>
            <div style={{ textAlign: 'right', flex: 1 }}>Subtotal</div>
            <div style={{ textAlign: 'right', width: '100px' }}>${Number(subtotal).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0' }}>
            <div style={{ textAlign: 'right', flex: 1 }}>TOTAL GST 15.00%</div>
            <div style={{ textAlign: 'right', width: '100px' }}>${Number(gstAmount).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
          </div>
          <div style={{ borderTop: '1px solid #000', margin: '8px 0' }}></div>
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0', fontWeight: 'bold', fontSize: '13px' }}>
            <div style={{ textAlign: 'right', flex: 1 }}>TOTAL (NZD)</div>
            <div style={{ textAlign: 'right', width: '100px' }}>${Number(total).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
          </div>
        </div>
      </div>

      {/* Footer Notes */}
      <div style={{ marginTop: '30px', fontSize: '10px', lineHeight: '1.6' }}>
        <div>Prior or Upon Collection of Documents. All reports remain property of GDC Consultants Ltd until paid for in full.</div>
        <div style={{ marginTop: '6px' }}>Bank Account Number - ANZ Bank - 06-0317-0939366-00 - GDC Consultants Ltd - Thank you</div>
        <div style={{ marginTop: '6px' }}>A late payment fee of 2% per month from the date of the invoice will be added to overdue accounts</div>
      </div>

      {/* Payment Advice Section */}
      <div style={{ marginTop: '40px', borderTop: '1px dashed #bdbcbcff', paddingTop: '20px' }}>
        <div style={{ fontWeight: 'bold', fontSize: '14px', marginBottom: '15px' }}>Payment Advice</div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', fontSize: '12px' }}>
          <div style={{ width: '50%' }}>
            <div style={{ marginBottom: '15px' }}>
              <div>Please detach this portion and return with your</div>
              <div>payment to:</div>
            </div>
            <div>
              <div>GDC Consultants Ltd</div>
              <div>PO Box 9403</div>
              <div>Hamilton</div>
            </div>
          </div>
          <div style={{ width: '45%' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
              <div style={{ fontWeight: 'bold' }}>Invoice No</div>
              <div>{formatValue(invoiceNo)}</div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
              <div style={{ fontWeight: 'bold' }}>Amount Due</div>
              <div>${Number(total).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
              <div style={{ fontWeight: 'bold' }}>Due Date</div>
              <div>{dueDate}</div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
              <div style={{ fontWeight: 'bold' }}>Amount Paid</div>
              <div style={{ borderBottom: '2px solid #000', width: '150px' }}></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
